import BaseService from './Base';

class AccountService extends BaseService {
  static endpoint = 'api/2.0/account-users/';
}

export default AccountService;